import React from 'react';
import {Brand} from './Landing';
import {useTranslation} from './localization';
export default function OnboardingNav({signOut}){
 const tr=useTranslation();
 return <header className="account-nav onboarding-nav"><div className="site-nav wrap"><Brand/><span className="setup-status">{tr('Account created · Set up your alerts')}</span><a className="text-link" href="mailto:info@earlybird.live">{tr('Support')}</a><button className="onboarding-signout" onClick={signOut}>{tr('Sign out')}</button></div></header>;
}
